'use strict';

import React, { useEffect } from 'react'

import MenuItem from '@Pure/MenuItem'
import Link     from '@Pure/Link'

import bemit from '@function/bemit'

import { isTrue } from '@root/utility'

const app = window.app;

export default function ECFrontSubmenu (props)
{
	const partners_access = app.state.session?.partners?.length > 0 ?
	(
		<MenuItem base_class="c-sub-menu__item" path="/espace-partenaires"
			history={ props.history }>
			<Link className="c-sub-menu__link" href="/espace-partenaires">
				Mes fiches partenaire
			</Link>
		</MenuItem>
	)
	: undefined;

	const syner_kado = isTrue(props.sorewards) ?
	(
		<MenuItem base_class="c-sub-menu__item" path="/accueil/mon-compte/syner-kado"
			history={ props.history }>
			<Link href="/accueil/mon-compte/syner-kado" className="c-sub-menu__link">
				Syner'Kado
			</Link>
		</MenuItem>
	)
	: undefined;

	let output =
	(
		<div className={ bemit('c-sub-menu', props.open ? ['open'] : []) }>

			<ul className="c-sub-menu__menu">

				{
					props['can-use-abondement'] ?
					(
						<li className="c-sub-menu__item is-abondement">
							<span className="c-sub-menu__link is-abondement"
								onClick={ props.onAbondementClick }>
								Abondement&nbsp;:
								{ ' ' }
								{ props.abondement }
								&nbsp;€
							</span>
						</li>
					)
					: undefined
				}

				<MenuItem base_class="c-sub-menu__item" path="/accueil/mon-compte"
					history={ props.history }>
					<Link href="/accueil/mon-compte" className="c-sub-menu__link">
						Mon compte
					</Link>
				</MenuItem>

				{ syner_kado }

				<MenuItem base_class="c-sub-menu__item" path="/panier"
					history={ props.history }>
					<Link href="/panier" className="c-sub-menu__link">
						Panier
					</Link>
				</MenuItem>

				<MenuItem base_class="c-sub-menu__item" path="/mes-commandes"
					history={ props.history }>
					<Link href="/mes-commandes" className="c-sub-menu__link">
						Mes commandes
					</Link>
				</MenuItem>

				<MenuItem base_class="c-sub-menu__item" path="/mes-factures"
					history={ props.history }>
					<Link href="/mes-factures" className="c-sub-menu__link">
						Mes factures
					</Link>
				</MenuItem>

				{ partners_access }

				<MenuItem base_class="c-sub-menu__item" path="/logout"
					history={ props.history }>
					<a href="/logout" className="c-sub-menu__link"
						onClick={ props.logout }>
						Déconnexion
					</a>
				</MenuItem>

			</ul>

		</div>
	);

	return output;
}